import {RouteProps} from 'config/navigation';

import Products from './products';
import CreateProduct from './create-product';
import ProductDetails from './product-details';
import CreateSize from './product-details/components/create-size';
import EditSize from './product-details/components/edit-size';
import CreateAdditionalGroupConfig from './product-details/components/create-additional-group-config';
import EditAdditionalGroupConfig from './product-details/components/edit-additional-group-config';
import {MdFastfood} from 'react-icons/md';
import CreateSale from './product-details/components/create-sale';
import EditSale from './product-details/components/edit-sale';
import ReorderProducts from './reorder-products';
import CreateWorkingPeriod from './product-details/components/create-working-period';

const productsPages: RouteProps = {
  name: 'Produtos',
  path: 'products',
  permission: 'products.findAll',
  icon: <MdFastfood />,
  subRoutes: [
    {
      path: '',
      element: <Products />,
      permissions: ['products.findAll'],
      modals: [
        {
          path: 'reorder',
          element: <ReorderProducts />,
        },
      ],
    },
    {
      path: 'create',
      element: <CreateProduct />,
      permissions: ['products.findOne'],
    },
    {
      path: ':id',
      element: <ProductDetails />,
      permissions: ['products.findOne'],
    },
    {
      path: ':id/working-periods',
      element: <ProductDetails activeTab="working-periods" />,
      permissions: ['products.findOne'],
      modals: [
        {
          title: 'Horário de funcionamento',
          path: 'create',
          element: <CreateWorkingPeriod />,
        },
      ],
    },
    {
      path: ':id/sizes',
      element: <ProductDetails activeTab="sizes" />,
      permissions: ['products.findOne'],
      modals: [
        {title: 'Cadastrar tamanho', path: 'create', element: <CreateSize />},
        {title: 'Editar tamanho', path: ':sizeId', element: <EditSize />},
      ],
    },
    {
      path: ':id/sales',
      element: <ProductDetails activeTab="sales" />,
      permissions: ['products.sales'],
      exactPermission: true,
      modals: [
        {
          title: 'Cadastrar promoção',
          path: 'create',
          element: <CreateSale />,
        },
        {
          title: 'Editar promoção',
          path: ':saleId',
          element: <EditSale />,
        },
      ],
    },
    {
      path: ':id/additional-group-configs',
      element: <ProductDetails activeTab="additional-group-configs" />,
      permissions: ['products.findOne'],
      modals: [
        {
          title: 'Cadastrar grupo de adicionais',
          path: 'create',
          element: <CreateAdditionalGroupConfig />,
        },
        {
          title: 'Editar grupo de adicionais',
          path: ':additionalGroupConfigId',
          element: <EditAdditionalGroupConfig />,
        },
      ],
    },
  ],
};

export default productsPages;
